import { Injectable, Injector } from '@angular/core';
import * as coreModels from 'libs/dc-core/models/base.models';
import { Observable } from 'rxjs';
import { DenReaderApi } from '../../base-apis/base-api';
import * as models from '../models/auto-generated-models';


@Injectable()
export class AgentDeploymentReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'agent');
         }
        downloadAgentForOnPrem(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.AgentUrl> {
       return this.getWithUrl<models.AgentUrl>("downloadAgentForOnPrem",_dependencies);
    };
             
}
 
@Injectable()
export class AgentSecuredWriterApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'agent');
         }
        enableAgentInstalled(_dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer> {
       return this.getWithUrl<coreModels.StatusContainer>("enableAgentInstalled",_dependencies);
    };
             
}
 
@Injectable()
export class CustomerMicroServicesConsoleReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'customerMicroServices');
         }
        findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.Microservice>>  {
       return this.getListWithUrl<Array<models.Microservice>>("findAll",_dependencies);
    };
             
 	 	findById(id: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.Microservice> {
       return this.getWithUrl<models.Microservice>("getById/"+id,_dependencies);
    };
             
}
 
@Injectable()
export class CustomerMicroServicesRuntimeReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.Microservice>>  {
       return this.getListWithUrl<Array<models.Microservice>>("findAll",_dependencies);
    };
             
 	 	findById(id: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.Microservice> {
       return this.getWithUrl<models.Microservice>("getById/"+id,_dependencies);
    };
             
}
 
@Injectable()
export class CustomerProfileReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'customerProfile');
         }
        getEnvDENState(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.UIEntityContainerHolder>>  {
       return this.getListWithUrl<Array<models.UIEntityContainerHolder>>("getEnvDENState",_dependencies);
    };
             
 	 	clientImageList(registryName: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ClientLatestImageResponse> {
       return this.getWithUrl<models.ClientLatestImageResponse>("images/list/"+registryName,_dependencies);
    };
             
 	 	getActiveSubscription(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.OrganizationDevumPlanSubscriptionsContainer> {
       return this.getWithUrl<models.OrganizationDevumPlanSubscriptionsContainer>("getActiveSubscription",_dependencies);
    };
             
 	 	clientImageRegistryFilter(obj: models.ClientImageRegistryFilterCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ClientImageRegistryFilterResponse>{
       return this.getByCustomFilterWithUrl<models.ClientImageRegistryFilterResponse>(obj, "images/filter",_dependencies);
    };
               
 	 	getCurrentState(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.UIEntityContainer> {
       return this.getWithUrl<models.UIEntityContainer>("getCurrentState",_dependencies);
    };
             
 	 	listClientImageRegistries(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ListClientImageRegistrationResponse> {
       return this.getWithUrl<models.ListClientImageRegistrationResponse>("clientImageRegistry/list",_dependencies);
    };
             
}
 
@Injectable()
export class DenDeploymentReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'DEN');
         }
        getRunningEnv(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.RunningEnvResponse> {
       return this.getWithUrl<models.RunningEnvResponse>("runningEnv",_dependencies);
    };
             
 	 	getResourceUtilization(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ResourceUtilizationUI> {
       return this.getWithUrl<models.ResourceUtilizationUI>("resourceUtilization",_dependencies);
    };
             
}
 
@Injectable()
export class InfraManagementReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'infra');
         }
        getNodeConfigs(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.NodeConfigResponse>>  {
       return this.getListWithUrl<Array<models.NodeConfigResponse>>("nodeConfigs",_dependencies);
    };
             
}
 
@Injectable()
export class MiniCrmReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'miniCrm');
         }
        getChildOrganizations(parentOrgCode: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.OrganizationSummary>> {
       return this.getListWithUrl<Array<models.OrganizationSummary>>("childOrganizations/"+parentOrgCode,_dependencies);
    };
             
 	 	getEnvironments(orgCode: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.Environment>> {
       return this.getListWithUrl<Array<models.Environment>>("environments/"+orgCode,_dependencies);
    };
             
 	 	getAllCustomSubscriptions(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.CustomSubscriptionResponse>>  {
       return this.getListWithUrl<Array<models.CustomSubscriptionResponse>>("customSubscriptions",_dependencies);
    };
             
 	 	getAllPendingUsers(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.SignUpRequest>>  {
       return this.getListWithUrl<Array<models.SignUpRequest>>("getPendingUsers",_dependencies);
    };
             
 	 	getAllOrganisations(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.OrganizationSummary>>  {
       return this.getListWithUrl<Array<models.OrganizationSummary>>("organizationSummaries",_dependencies);
    };
             
}
 
@Injectable()
export class MonitoringReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'monitor');
         }
        getMeeterings(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.MeetringComponent>>  {
       return this.getListWithUrl<Array<models.MeetringComponent>>("meeterings",_dependencies);
    };
             
 	 	triggerPodLogs(obj: models.GetPodLogsCmdUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "logs/pods",_dependencies);
    };
               
 	 	triggerKubernetesLogs(obj: models.GetKubernetesLogsCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "logs/kubernetes",_dependencies);
    };
               
 	 	triggerSharedMSPodLogs(obj: models.GetSharedMSPodLogsCmdUI , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "logs/pods/devum",_dependencies);
    };
               
 	 	getRegionHealthStatus(region: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.HealthStatus>> {
       return this.getListWithUrl<Array<models.HealthStatus>>("health/"+region,_dependencies);
    };
             
 	 	triggerSharedMSKubernetesLogs(obj: models.GetKubernetesLogsCmd , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "logs/kubernetes/devum",_dependencies);
    };
               
}
 
@Injectable()
export class OrgImageMappingReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'orgImageMapping');
         }
        
}
 
@Injectable()
export class PlanReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'plans');
         }
        getMinResourceQuota(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.PlanMinResourceQuota>>  {
       return this.getListWithUrl<Array<models.PlanMinResourceQuota>>("minResourceQuota",_dependencies);
    };
             
 	 	getAddonsPricing(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.AddOnPricing>>  {
       return this.getListWithUrl<Array<models.AddOnPricing>>("addOnPricing",_dependencies);
    };
             
 	 	getAllPricing(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.DevumPlanPricing>>  {
       return this.getListWithUrl<Array<models.DevumPlanPricing>>("pricing",_dependencies);
    };
             
 	 	getAllFeatures(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.DevumPlanFeature>>  {
       return this.getListWithUrl<Array<models.DevumPlanFeature>>("planFeatures",_dependencies);
    };
             
 	 	getAllPlans(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.DevumPlan>>  {
       return this.getListWithUrl<Array<models.DevumPlan>>("getAll",_dependencies);
    };
             
 	 	getPlatformFeatures(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.DevumPlatformFeatureUI>>  {
       return this.getListWithUrl<Array<models.DevumPlatformFeatureUI>>("features",_dependencies);
    };
             
}
 
@Injectable()
export class PlanReaderRunTimeApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        
}
 
@Injectable()
export class PreLoginReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        resolveUserPool(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.UserPoolPrecis> {
       return this.getWithUrl<models.UserPoolPrecis>("resolveUserPool",_dependencies);
    };
             
}
 
@Injectable()
export class RegionEKSClusterNodeGroupReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'regionEKSClusterNodeGroupInfo');
         }
        findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.RegionEKSClusterNodeGroupInfo>>  {
       return this.getListWithUrl<Array<models.RegionEKSClusterNodeGroupInfo>>("findAll",_dependencies);
    };
             
 	 	findCustomerSharedNodeGroup(region: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.RegionEKSClusterNodeGroupInfo> {
       return this.getWithUrl<models.RegionEKSClusterNodeGroupInfo>("findCustomerSharedNodeGroup/"+region,_dependencies);
    };
             
}
 
@Injectable()
export class RegionEKSClusterReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'clusters');
         }
        namespaces(obj: models.GetNamespaceResponse , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.GetNamespaces>{
       return this.getByCustomFilterWithUrl<models.GetNamespaces>(obj, "namespaces",_dependencies);
    };
               
 	 	findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.RegionEKSCluster>>  {
       return this.getListWithUrl<Array<models.RegionEKSCluster>>("findAll",_dependencies);
    };
             
 	 	clusterInfo(obj: models.GetClusterInfo , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ClusterInfoResponse>{
       return this.getByCustomFilterWithUrl<models.ClusterInfoResponse>(obj, "clusterInfo",_dependencies);
    };
               
 	 	hostedOrg(region: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.OrgPlanMapping>> {
       return this.getListWithUrl<Array<models.OrgPlanMapping>>("hostedOrg/"+region,_dependencies);
    };
             
}
 
@Injectable()
export class RetryCommandsReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'retryCommandReader');
         }
        getStateInfo(obj: models.QueryCustomerProfileStateInfo , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.CustomerProfileCommandStateInfo>{
       return this.getByCustomFilterWithUrl<models.CustomerProfileCommandStateInfo>(obj, "getCustomerProfileCommandStateInfo",_dependencies);
    };
               
 	 	getDenDeploymentManagerCommandStateInfo(obj: models.QueryDeploymentStateInfo , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.DenDeploymentCommandStateInfo>{
       return this.getByCustomFilterWithUrl<models.DenDeploymentCommandStateInfo>(obj, "getDenDeploymentManagerCommandStateInfo",_dependencies);
    };
               
 	 	sharedMicroserviceStateInfo(obj: models.QuerySharedMicroserviceStateInfo , _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.SharedMicroserviceStateInfo>{
       return this.getByCustomFilterWithUrl<models.SharedMicroserviceStateInfo>(obj, "sharedMicroserviceStateInfo",_dependencies);
    };
               
}
 
@Injectable()
export class RuntimeApiReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        
}
 
@Injectable()
export class SharedMicroServicesConsoleReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'sharedMicroServices');
         }
        findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.Microservice>>  {
       return this.getListWithUrl<Array<models.Microservice>>("findAll",_dependencies);
    };
             
 	 	findById(id: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.Microservice> {
       return this.getWithUrl<models.Microservice>("getById/"+id,_dependencies);
    };
             
 	 	getSharedMSStateInfo(region: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.UIEntityContainer>> {
       return this.getListWithUrl<Array<models.UIEntityContainer>>("sharedMSStateInfo/"+region,_dependencies);
    };
             
}
 
@Injectable()
export class SharedMicroServicesRuntimeReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, '');
         }
        findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.Microservice>>  {
       return this.getListWithUrl<Array<models.Microservice>>("findAll",_dependencies);
    };
             
 	 	findById(id: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.Microservice> {
       return this.getWithUrl<models.Microservice>("getById/"+id,_dependencies);
    };
             
}
 
@Injectable()
export class SubscriptionReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'subscriptions');
         }
        handleGetPaymentMethod(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.PaymentMethodCardsInfo>>  {
       return this.getListWithUrl<Array<models.PaymentMethodCardsInfo>>("paymentMethod",_dependencies);
    };
             
 	 	handleCreatePaymentIntent(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.SetupIntentInfo> {
       return this.getWithUrl<models.SetupIntentInfo>("setupPaymentIntent",_dependencies);
    };
             
 	 	handleCurrencyConversion(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.CurrencyResponse> {
       return this.getWithUrl<models.CurrencyResponse>("currencyConversion",_dependencies);
    };
             
}
 
@Injectable()
export class SupportedRegionReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'regions');
         }
        action(obj: models.ActionRequest , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "action",_dependencies);
    };
               
 	 	findAll(_dependencies?: Array<coreModels.DependencyProperty>):Observable<Array<models.SupportedRegion>>  {
       return this.getListWithUrl<Array<models.SupportedRegion>>("findAll",_dependencies);
    };
             
 	 	getNodes(region: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.RegionUtilizationContainer> {
       return this.getWithUrl<models.RegionUtilizationContainer>("nodes/"+region,_dependencies);
    };
             
 	 	fetchLogs(obj: models.FetchLogsRequest , _dependencies?: Array<coreModels.DependencyProperty>):Observable<coreModels.StatusContainer>{
       return this.getByCustomFilterWithUrl<coreModels.StatusContainer>(obj, "fetchLogs",_dependencies);
    };
               
 	 	getSupportedRegions(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.ValidRegions> {
       return this.getWithUrl<models.ValidRegions>("supported",_dependencies);
    };
             
 	 	getConfigurations(region: string, _dependencies?: Array<coreModels.DependencyProperty>):Observable<models.RegionConfigurations> {
       return this.getWithUrl<models.RegionConfigurations>("configurations/"+region,_dependencies);
    };
             
}
 
@Injectable()
export class UserAccountReaderApi extends DenReaderApi {

        constructor(injector: Injector) {
            super(injector, 'userAccounts');
         }
        getUserInfo(_dependencies?: Array<coreModels.DependencyProperty>):Observable<models.UserInfo> {
       return this.getWithUrl<models.UserInfo>("info",_dependencies);
    };
             
}
